export const USER_MANAGEMENT_PERMISSION = "hotel_settings.manage_users";

export function hasUserManagementPermission(user) {
  return (
    Number(user?.id) === 1 ||
    user?.permissions?.[USER_MANAGEMENT_PERMISSION] === true
  );
}

export function canManageTargetUser(currentUser, targetUser) {
  if (!hasUserManagementPermission(currentUser)) return false;
  if (Number(currentUser?.id) === Number(targetUser?.id)) return false;
  if (Number(targetUser?.id) === 1 && targetUser?.is_active !== false) return false;
  return true;
}

export function canPermanentlyDeleteTargetUser(currentUser, targetUser) {
  return (
    Number(targetUser?.id) !== 1 &&
    canManageTargetUser(currentUser, targetUser) &&
    (targetUser?.is_active === false || targetUser?.password_configured === false)
  );
}
